import { FC, MouseEvent, useCallback, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { ArrowNextIcon, Button } from '@customink/pigment-react';
import { useMenu } from '~/components/Menu/useMenu';
import { Design } from '~/adapters/services/accounts/designs/types';
import { trackEvent } from '~/adapters/tracking/tracking';
import { gaCategoryNew } from '../tracking';
import { OrderOptionsMenu } from './OrderOptionsMenu';

type OrderOptionsButtonProps = {
    design: Design;
    cardIndex: number;
};

export const OrderOptionsButton: FC<OrderOptionsButtonProps> = ({ design, cardIndex }) => {
    const menu = useMenu();

    const handleButtonClick = useCallback(
        (e: MouseEvent<HTMLElement>) => {
            trackEvent({ category: gaCategoryNew, action: 'Button Click', label: 'View Order Options' });
            menu.handleOpen(e);
        },
        [menu.handleOpen],
    );

    // only for Add to Cart button (Test C) in the menu
    const [buyWaiting, setBuyWaiting] = useState(false);

    return (
        <>
            <Button
                onClick={handleButtonClick}
                variant="secondary"
                fullWidth
                endIcon={<ArrowNextIcon />}
                sx={{
                    justifyContent: 'space-between',
                    '.MuiButton-endIcon	': { marginLeft: 0 },
                }}
            >
                {/* empty element so that the label is centered, but icon is at end */}
                <span />
                {buyWaiting ? <CircularProgress color="secondary" size={24} /> : <span>View Order Options</span>}
            </Button>
            <OrderOptionsMenu
                design={design}
                anchorElement={menu.anchorEl}
                handleClose={menu.handleClose}
                buyWaiting={buyWaiting}
                setBuyWaiting={setBuyWaiting}
                cardIndex={cardIndex}
            />
        </>
    );
};
